// Вторинні сторінки — каруселі FancyBox

window.addEventListener("load", function () {
  // Товари, пов'язані з Акцією або Новиною
  const container0 = document.getElementById("fbox__related-prods");
  if (container0) {
    new Carousel(container0, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 4,
      center: false,
      infinite: true,
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Партнери (також на Головній)
  const container3 = document.getElementById("partners");
  if (container3) {
    new Carousel(container3, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4000, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Популярні товари (/catalog, субкатегорії)
  const container1 = document.getElementById("popular-products");
  if (container1) {
    new Carousel(container1, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4000, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Нещодавно переглянуті товари
  const container2 = document.getElementById("recently-read");
  if (container2) {
    new Carousel(container2, {
      Dots: false,
      Thumbs: { type: "classic" },
      slidesPerPage: 10,
      center: false,
      infinite: true,
      Autoplay: { timeout: 4000, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }

  // Акції на /basket/
  const container4 = document.getElementById("fbox__aktcii");
  if (container4) {
    new Carousel(container4, {
      Dots: false,
      Thumbs: { type: "classic" },
      center: false,
      infinite: true,
      Autoplay: { timeout: 5000, pauseOnHover: false },
      l10n: { NEXT: "Наступний слайд", PREV: "Попередній слайд" },
    });
  }
});
